import React, { useMemo } from 'react'

import { Box, Flex, Text, SVG } from 'system'
import { Heading } from './Heading'
import { ReactComponent as AssetIconInfoSVG } from '../assets/icon-alert.svg'
import { ReactComponent as AssetIconWarningSVG } from '../assets/icon-warning.svg'

const getTheme = type => {
  switch (type) {
    case 'warning':
      return {
        bg: 'yellow.90',
        borderColor: 'yellow.60',
        color: 'yellow.60',
        svg: AssetIconInfoSVG,
      }

    case 'danger':
      return {
        bg: 'red.90',
        borderColor: 'red.50',
        color: 'red.50',
        svg: AssetIconWarningSVG,
      }

    default:
      return {
        bg: 'purple.100',
        borderColor: 'purple.90',
        color: 'purple.50',
        svg: AssetIconInfoSVG,
      }
  }
}

export const Callout = ({ type, children, heading, ...props }) => {
  const theme = useMemo(() => getTheme(type), [type])

  return (
    <Box
      bg={theme.bg}
      border="1px solid"
      borderColor={theme.borderColor}
      borderRadius={8}
      color="gray.10"
      myScale="l"
      pScale="m"
      {...props}
    >
      <Flex alignItems="flex-start">
        <SVG
          x={1}
          y={1}
          svg={theme.svg}
          fill={theme.color}
          flex="0 0 auto"
          mrScale="s-"
          position="relative"
          width="1.25rem"
          transform={heading ? 'translateY(-10%)' : 'translateY(20%)'}
        />
        <Text flex="1 1 auto" lineHeight="copyTight">
          {heading && (
            <Heading as="h4" fontSizeScale="m" mbScale="t-">
              {heading}
            </Heading>
          )}
          {children}
        </Text>
      </Flex>
    </Box>
  )
}
